import React, { useState } from 'react'
import 'react-alice-carousel/lib/alice-carousel.css'
import { Link } from 'react-router-dom'
import Slider from 'react-slick'
import './styles.css'

export default function ProductItemChickenGravy() {
  const [active, setActive] = useState('คำอธิบาย')
  const [select, setSelect] = useState('jelly')
  const renderProductItemBackground = <div className="product-item-background"></div>

  const renderVarationItem = (
    <>
      <div className="product-item-variation-title">Select Variations:</div>
      <div className="variation-wrapper">
        <button
          className={select === 'jelly' ? 'variation-item active' : 'variation-item'}
          onClick={() => setSelect('jelly')}>
          <div className="product-card-img-tuna-chicken-jelly-img" />
          <div className="variation-title">อาหารเปียกแมวสูตรปลาทูน่าไก่ในเยลลี่</div>
        </button>
        <button
          className={select === 'gravy' ? 'variation-item active' : 'variation-item'}
          onClick={() => setSelect('gravy')}>
          <div className="product-card-img-tuna-chicken-gravy-img" />
          <div className="variation-title">อาหารเปียกแมวสูตรปลาทูน่าไก่ในเกรวี่</div>
        </button>
      </div>
    </>
  )

  const renderSizeOption = (
    <>
      <div className="product-item-size-title">Sizes: </div>
      <div className="size-wrapper">
        <button className="size-item">กระป๋อง ขนาด 85g.</button>
        <button className="size-item">กระป๋อง ขนาด 170g.</button>
        <button className="size-item">ซอง ขนาด 70g.</button>
      </div>
    </>
  )

  const renderIngredients = (
    <>
      <div className="product-item-ingredient-title">Key ingredientS</div>
      {/* <div className="ingredient-wrapper">
        <div className="ingredient-item">
          alt="cat's taste" className="ingredient-img" src="/assets/icons/tuna-ingredient.svg" />
          <div className="ingredient-title">Just tuna!</div>
        </div>
        <div className="ingredient-item">
          alt="cat's taste" className="ingredient-img" src="/assets/icons/chicken-ingredient.svg" />
          <div className="ingredient-title">Chicken topping</div>
        </div>
        <div className="ingredient-item">
          alt="cat's taste" className="ingredient-img" src="/assets/icons/salmon-ingredient.svg" />
          <div className="ingredient-title">Salmon topping</div>
        </div>
        <div className="ingredient-item">
          alt="cat's taste" className="ingredient-img" src="/assets/icons/rice-fish-ingredient.svg" />
          <div className="ingredient-title">Rice fish topping</div>
        </div>
      </div> */}
      <div className="ingredient-wrapper">
        <div className="ingredient-item">
          <img alt="cat's taste" className="ingredient-img" src="/assets/icons/cat-mouth.svg" />
          <div className="ingredient-title">ปลาทูน่า</div>
        </div>
        <div className="ingredient-item">
          <img alt="cat's taste" className="ingredient-img" src="/assets/icons/cat-mouth.svg" />
          <div className="ingredient-title">เนื้อไก่</div>
        </div>
        <div className="ingredient-item">
          <img alt="cat's taste" className="ingredient-img" src="/assets/icons/cat-mouth.svg" />
          <div className="ingredient-title">น้ำนึ่งปลาทู</div>
        </div>
        <div className="ingredient-item">
          <img alt="cat's taste" className="ingredient-img" src="/assets/icons/cat-mouth.svg" />
          <div className="ingredient-title">ทอรีน</div>
        </div>
        <div className="ingredient-item">
          <img alt="cat's taste" className="ingredient-img" src="/assets/icons/cat-mouth.svg" />
          <div className="ingredient-title">วิตามินอี</div>
        </div>
      </div>
    </>
  )

  const renderDescription = (
    <div>
      <div className="description-header">
        <div
          className={active === 'คำอธิบาย' ? 'description-btn-background1' : 'description-btn-background'}
          onClick={() => setActive('คำอธิบาย')}>
          คำอธิบาย
        </div>
        <div
          className={
            active === 'วิธีการให้อาหารแมวในแต่ละวัน' ? 'description-btn-background2' : 'description-btn-background'
          }
          onClick={() => setActive('วิธีการให้อาหารแมวในแต่ละวัน')}>
          วิธีการให้อาหารแมวในแต่ละวัน
        </div>
        <div
          className={active === 'คำแนะนำในการเก็บรักษา' ? 'description-btn-background3' : 'description-btn-background'}
          onClick={() => setActive('คำแนะนำในการเก็บรักษา')}>
          คำแนะนำในการเก็บรักษา
        </div>
      </div>
      {active === 'คำอธิบาย' && (
        <div className="description-wrapper">
          <div className="description-item">
            <img alt="cat's taste" className="description-img" src="/assets/icons/our-value-sodium-red.png" />
            <div className="description-title">No sodium added</div>
          </div>
          <div className="description-item">
            <img alt="cat's taste" className="description-img" src="/assets/icons/our-value-grain-red.png" />
            <div className="description-title">Grain Free</div>
          </div>
          <div className="description-item">
            <img alt="cat's taste" className="description-img" src="/assets/icons/our-value-preservative-red.png" />
            <div className="description-title">No Preservatives</div>
          </div>
          <div className="description-item">
            <img alt="cat's taste" className="description-img" src="/assets/icons/our-value-quality-red.png" />
            <div className="description-title">Japanese quality</div>
          </div>
          <div className="description-item">
            <img alt="cat's taste" className="description-img" src="/assets/icons/our-value-human-red.png" />
            <div className="description-title">HUMAN GRADE FOOD</div>
          </div>
        </div>
      )}
      {active === 'วิธีการให้อาหารแมวในแต่ละวัน' && (
        <div className="methods-wrapper">
          <div className="methods-item">
            <div className="cat-weight-title">นน. แมว 1-3 กก.</div>
            <img alt="cat's taste" className="cat-weight1" src="/assets/icons/cat-weight.svg" />
            <div className="cat-weight-pack-wrapper1">
              <img
                alt="cat's taste"
                className="cat-weight-pack1"
                src={
                  select === 'gravy' ? '/assets/icons/chicken-gravy-pack1.svg' : '/assets/icons/chicken-jelly-pack1.svg'
                }
              />
              <div className="cat-weight-subtitle">2/5 - 4/5 ถุง/วัน</div>
            </div>
          </div>
          <div className="methods-item">
            <div className="cat-weight-title">นน. แมว 3-5 กก.</div>
            <img alt="cat's taste" className="cat-weight2" src="/assets/icons/cat-weight.svg" />
            <div className="cat-weight-pack-wrapper2">
              <img
                alt="cat's taste"
                className="cat-weight-pack2"
                src={
                  select === 'gravy' ? '/assets/icons/chicken-gravy-pack2.svg' : '/assets/icons/chicken-jelly-pack2.svg'
                }
              />
              {select === 'gravy' ? (
                <div className="cat-weight-subtitle">4/5 - 1, 1/5 ถุง/วัน</div>
              ) : (
                <div className="cat-weight-subtitle">4/5 - 1 ถุง/วัน</div>
              )}
            </div>
          </div>
          <div className="methods-item">
            <div className="cat-weight-title">นน. แมว 5+ กก.</div>
            <img alt="cat's taste" className="cat-weight3" src="/assets/icons/cat-weight.svg" />
            <div className="cat-weight-pack-wrapper3">
              <img
                alt="cat's taste"
                className="cat-weight-pack3"
                src={
                  select === 'gravy' ? '/assets/icons/chicken-gravy-pack3.svg' : '/assets/icons/chicken-jelly-pack3.svg'
                }
              />
              {select === 'gravy' ? (
                <div className="cat-weight-subtitle">1, 1/5+ ถุง/วัน</div>
              ) : (
                <div className="cat-weight-subtitle">1 ถุง+/วัน</div>
              )}
            </div>
          </div>
        </div>
      )}
      {active === 'คำแนะนำในการเก็บรักษา' && (
        <div className="instruction">
          <div className="instruction-title">วิธีใช้และขนาดการใช้</div>
          <div className="instruction-subtitle">บริโภคได้ทันทีหลังจากเปิดถุง</div>
          <div className="instruction-subtitle">
            ควรให้อาหารอื่นเพิ่มเติมเพื่อให้แมวได้รับสารอาหารเพียงพอต่อความต้องการของร่างกาย
          </div>
          <div className="instruction-subtitle">หลังจากเปิดถุงควรเก็บไว้ในตู้เย็น เก็บได้ไม่เกิน 2 วัน</div>
        </div>
      )}
    </div>
  )

  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 1000,
    autoplaySpeed: 2000,
    slidesToShow: 3,
    slidesToScroll: 3,
    dots: true,
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  }

  const renderSlider = (
    <>
      <div className="carousel-header-background"></div>
      <div className="project-item-container">
        <link
          rel="stylesheet"
          type="text/css"
          charset="UTF-8"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
        />
        <div className="product-item-carousel-header">
          <div className="carousel-tasty-wrapper">
            <img alt="cat's taste" src="/assets/icons/cat-mouth.svg" />
            <div className="carousel-title-tasty">Tasty</div>
          </div>
          <button className="shop-now-btn">SHOP NOW</button>
        </div>
        <Slider {...settings}>
          <a className="carousel-item" href="just-tuna-jelly">
            <div className="product-card-img-just-tuna-jelly-carousel" />
            <div className="carousel-item-title">Just Tuna! in Jelly</div>
            <div className="carousel-item-subtitle1">อาหารเปียกแมว</div>
            <div className="carousel-item-subtitle2">สูตรปลาทูน่าในเยลลี่</div>
            <div className="carousel-btn-wrapper">
              <a
                className="carousel-btn"
                href="https://shopee.co.th/%E0%B8%AD%E0%B8%B2%E0%B8%AB%E0%B8%B2%E0%B8%A3%E0%B9%80%E0%B8%9B%E0%B8%B5%E0%B8%A2%E0%B8%81%E0%B9%81%E0%B8%A1%E0%B8%A7-%E0%B9%81%E0%B8%84%E0%B8%97%E0%B9%80%E0%B8%97%E0%B8%AA%E0%B8%95%E0%B9%8C-%E0%B8%97%E0%B8%B9%E0%B8%99%E0%B9%88%E0%B8%B2%E0%B8%AB%E0%B8%99%E0%B9%89%E0%B8%B2%E0%B8%9B%E0%B8%A5%E0%B8%B2%E0%B8%8A%E0%B8%B4%E0%B8%A3%E0%B8%B0%E0%B8%AA%E0%B8%B8-%E0%B9%83%E0%B8%99%E0%B9%80%E0%B8%A2%E0%B8%A5%E0%B8%A5%E0%B8%B5%E0%B9%88-%E0%B8%82%E0%B8%99%E0%B8%B2%E0%B8%94-75-%E0%B8%81%E0%B8%A3%E0%B8%B1%E0%B8%A1-x-12-%E0%B8%8B%E0%B8%AD%E0%B8%87-i.582216451.13557838247?sp_atk=1f84ba56-8e0d-4666-98f3-e23fa5ff7a35">
                SHOPEE
              </a>
              <a
                className="carousel-btn"
                href="https://www.lazada.co.th/products/cats-taste-75-x-12-i2959174142-s10850108135.html?spm=a2o4m.seller.list.7.6f67fd3aLPhNPW&mp=1">
                LAZADA
              </a>
            </div>
          </a>
          <a className="carousel-item" href="just-tuna-gravy">
            <div className="product-card-img-just-tuna-gravy-carousel" />
            <div className="carousel-item-title">Just Tuna! in Gravy</div>
            <div className="carousel-item-subtitle1">อาหารเปียกแมว</div>
            <div className="carousel-item-subtitle2">สูตรปลาทูน่าในเกรวี่</div>
            <div className="carousel-btn-wrapper">
              <a
                className="carousel-btn"
                href="https://shopee.co.th/%E0%B8%AD%E0%B8%B2%E0%B8%AB%E0%B8%B2%E0%B8%A3%E0%B9%80%E0%B8%9B%E0%B8%B5%E0%B8%A2%E0%B8%81%E0%B9%81%E0%B8%A1%E0%B8%A7-%E0%B9%81%E0%B8%84%E0%B8%97%E0%B9%80%E0%B8%97%E0%B8%AA%E0%B8%95%E0%B9%8C-%E0%B8%97%E0%B8%B9%E0%B8%99%E0%B9%88%E0%B8%B2-%E0%B9%83%E0%B8%99%E0%B8%99%E0%B9%89%E0%B8%B3%E0%B9%80%E0%B8%81%E0%B8%A3%E0%B8%A7%E0%B8%B5%E0%B9%88-%E0%B8%82%E0%B8%99%E0%B8%B2%E0%B8%94-75-%E0%B8%81%E0%B8%A3%E0%B8%B1%E0%B8%A1-x-12-%E0%B8%8B%E0%B8%AD%E0%B8%87-i.582216451.14812964729?sp_atk=15cb64b7-b6cf-48a9-a8c9-f94293d58af5">
                SHOPEE
              </a>
              <a
                className="carousel-btn"
                href="https://www.lazada.co.th/products/cats-taste-75-x-12-i2959118388-s10850105196.html?spm=a2o4m.seller.list.3.6f67fd3aWEjix8&mp=1">
                LAZADA
              </a>
            </div>
          </a>
          <a className="carousel-item" href="shirasu-jelly">
            <div className="product-card-img-shirasu-jelly-carousel" />
            <div className="carousel-item-title">Tuna topped with Shirasu in Jelly</div>
            <div className="carousel-item-subtitle1">อาหารเปียกแมว</div>
            <div className="carousel-item-subtitle2">สูตรปลาทูน่าหน้าชิระสุในเยลลี่</div>
            <div className="carousel-btn-wrapper">
              <a
                className="carousel-btn"
                href="https://shopee.co.th/%E0%B8%AD%E0%B8%B2%E0%B8%AB%E0%B8%B2%E0%B8%A3%E0%B9%80%E0%B8%9B%E0%B8%B5%E0%B8%A2%E0%B8%81%E0%B9%81%E0%B8%A1%E0%B8%A7-%E0%B9%81%E0%B8%84%E0%B8%97%E0%B9%80%E0%B8%97%E0%B8%AA%E0%B8%95%E0%B9%8C-%E0%B8%97%E0%B8%B9%E0%B8%99%E0%B9%88%E0%B8%B2%E0%B8%AB%E0%B8%99%E0%B9%89%E0%B8%B2%E0%B8%9B%E0%B8%A5%E0%B8%B2%E0%B8%8A%E0%B8%B4%E0%B8%A3%E0%B8%B0%E0%B8%AA%E0%B8%B8-%E0%B9%83%E0%B8%99%E0%B9%80%E0%B8%A2%E0%B8%A5%E0%B8%A5%E0%B8%B5%E0%B9%88-%E0%B8%82%E0%B8%99%E0%B8%B2%E0%B8%94-75-%E0%B8%81%E0%B8%A3%E0%B8%B1%E0%B8%A1-x-12-%E0%B8%8B%E0%B8%AD%E0%B8%87-i.582216451.13557838247?sp_atk=1f84ba56-8e0d-4666-98f3-e23fa5ff7a35">
                SHOPEE
              </a>
              <a
                className="carousel-btn"
                href="https://www.lazada.co.th/products/cats-taste-75-x-12-i2959062823-s10850055500.html?spm=a2o4m.seller.list.11.4d82fd3auOnu01&mp=1">
                LAZADA
              </a>
            </div>
          </a>
          <a className="carousel-item" href="shirasu-gravy">
            <div className="product-card-img-shirasu-gravy-carousel" />
            <div className="carousel-item-title">Tuna topped with Shirasu in Gravy</div>
            <div className="carousel-item-subtitle1">อาหารเปียกแมว</div>
            <div className="carousel-item-subtitle2">สูตรปลาทูน่าหน้าชิระสุในเกรวี่</div>
            <div className="carousel-btn-wrapper">
              <a
                className="carousel-btn"
                href="https://shopee.co.th/%E0%B8%AD%E0%B8%B2%E0%B8%AB%E0%B8%B2%E0%B8%A3%E0%B9%80%E0%B8%9B%E0%B8%B5%E0%B8%A2%E0%B8%81%E0%B9%81%E0%B8%A1%E0%B8%A7-%E0%B9%81%E0%B8%84%E0%B8%97%E0%B9%80%E0%B8%97%E0%B8%AA%E0%B8%95%E0%B9%8C-%E0%B8%97%E0%B8%B9%E0%B8%99%E0%B9%88%E0%B8%B2%E0%B8%AB%E0%B8%99%E0%B9%89%E0%B8%B2%E0%B8%9B%E0%B8%A5%E0%B8%B2%E0%B8%8A%E0%B8%B4%E0%B8%A3%E0%B8%B0%E0%B8%AA%E0%B8%B8-%E0%B9%83%E0%B8%99%E0%B8%99%E0%B9%89%E0%B8%B3%E0%B9%80%E0%B8%81%E0%B8%A3%E0%B8%A7%E0%B8%B5%E0%B9%88-%E0%B8%82%E0%B8%99%E0%B8%B2%E0%B8%94-75-%E0%B8%81%E0%B8%A3%E0%B8%B1%E0%B8%A1-x-12-%E0%B8%8B%E0%B8%AD%E0%B8%87-i.582216451.11276164400?sp_atk=6286b41a-d385-45e2-b3be-ca76adf12e2a">
                SHOPEE
              </a>
              <a
                className="carousel-btn"
                href="https://www.lazada.co.th/products/cats-taste-75-x-12-i2959144271-s10849995881.html?spm=a2o4m.seller.list.3.4d82fd3auOnu01&mp=1">
                LAZADA
              </a>
            </div>
          </a>
          <a className="carousel-item" href="salmon-jelly">
            <div className="product-card-img-salmon-jelly-carousel" />
            <div className="carousel-item-title">Tuna topped with Salmon in Jelly</div>
            <div className="carousel-item-subtitle1">อาหารเปียกแมว</div>
            <div className="carousel-item-subtitle2">สูตรปลาทูน่าหน้าแซลม่อนในเยลลี่</div>
            <div className="carousel-btn-wrapper">
              <a
                className="carousel-btn"
                href="https://shopee.co.th/%E0%B8%AD%E0%B8%B2%E0%B8%AB%E0%B8%B2%E0%B8%A3%E0%B9%80%E0%B8%9B%E0%B8%B5%E0%B8%A2%E0%B8%81%E0%B9%81%E0%B8%A1%E0%B8%A7-%E0%B9%81%E0%B8%84%E0%B8%97%E0%B9%80%E0%B8%97%E0%B8%AA%E0%B8%95%E0%B9%8C-%E0%B8%97%E0%B8%B9%E0%B8%99%E0%B9%88%E0%B8%B2%E0%B8%AB%E0%B8%99%E0%B9%89%E0%B8%B2%E0%B8%9B%E0%B8%A5%E0%B8%B2%E0%B9%81%E0%B8%8B%E0%B8%A5%E0%B8%A1%E0%B8%AD%E0%B8%99-%E0%B9%83%E0%B8%99%E0%B9%80%E0%B8%A2%E0%B8%A5%E0%B8%A5%E0%B8%B5%E0%B9%88-%E0%B8%82%E0%B8%99%E0%B8%B2%E0%B8%94-75-%E0%B8%81%E0%B8%A3%E0%B8%B1%E0%B8%A1-x-12-%E0%B8%8B%E0%B8%AD%E0%B8%87-i.582216451.14612965759?sp_atk=75b5740c-dd28-4e6d-aa0f-d6d3b15ff534">
                SHOPEE
              </a>
              <a
                className="carousel-btn"
                href="https://www.lazada.co.th/products/cats-taste-75-x-12-i2959101540-s10850126167.html?spm=a2o4m.seller.list.5.306ffd3aRf0b3M&mp=1">
                LAZADA
              </a>
            </div>
          </a>
          <a className="carousel-item" href="salmon-gravy">
            <div className="product-card-img-salmon-gravy-carousel" />
            <div className="carousel-item-title">Tuna topped with Salmon in Gravy</div>
            <div className="carousel-item-subtitle1">อาหารเปียกแมว</div>
            <div className="carousel-item-subtitle2">สูตรปลาทูน่าหน้าแซลม่อนในเกรวี่</div>
            <div className="carousel-btn-wrapper">
              <a
                className="carousel-btn"
                href="https://shopee.co.th/%E0%B8%AD%E0%B8%B2%E0%B8%AB%E0%B8%B2%E0%B8%A3%E0%B9%80%E0%B8%9B%E0%B8%B5%E0%B8%A2%E0%B8%81%E0%B9%81%E0%B8%A1%E0%B8%A7-%E0%B9%81%E0%B8%84%E0%B8%97%E0%B9%80%E0%B8%97%E0%B8%AA%E0%B8%95%E0%B9%8C-%E0%B8%97%E0%B8%B9%E0%B8%99%E0%B9%88%E0%B8%B2%E0%B8%AB%E0%B8%99%E0%B9%89%E0%B8%B2%E0%B8%9B%E0%B8%A5%E0%B8%B2%E0%B9%81%E0%B8%8B%E0%B8%A5%E0%B8%A1%E0%B8%AD%E0%B8%99-%E0%B9%83%E0%B8%99%E0%B8%99%E0%B9%89%E0%B8%B3%E0%B9%80%E0%B8%81%E0%B8%A3%E0%B8%A7%E0%B8%B5%E0%B9%88-%E0%B8%82%E0%B8%99%E0%B8%B2%E0%B8%94-75-%E0%B8%81%E0%B8%A3%E0%B8%B1%E0%B8%A1-x-12-%E0%B8%8B%E0%B8%AD%E0%B8%87-i.582216451.12857853577?sp_atk=87d3ad52-8e3a-4b90-abd0-eda7857f2462">
                SHOPEE
              </a>
              <a
                className="carousel-btn"
                href="https://www.lazada.co.th/products/cats-taste-75-x-12-i2959100551-s10849994882.html?spm=a2o4m.seller.list.7.306ffd3aRf0b3M&mp=1">
                LAZADA
              </a>
            </div>
          </a>
        </Slider>
      </div>
    </>
  )

  return (
    <div>
      {renderProductItemBackground}
      <div className="product-item-card">
        <div className="product-item-card-grid">
          <div
            className={
              select === 'gravy'
                ? 'product-card-img-tuna-chicken-gravy-item'
                : 'product-card-img-tuna-chicken-jelly-item'
            }
          />
          <div className="product-item-detail">
            <div className="product-item-card-title-grid">
              <img alt="cat's taste" className="cat-mouth-img" src="/assets/icons/cat-mouth.svg" />
              <div>
                <div className="product-item-card-title">Tuna topped with Chicken in Gravy</div>
                <div className="product-item-card-subtitle">อาหารเปียกแมวสูตรปลาทูน่าไก่ในเกรวี่</div>
              </div>
            </div>
            {renderVarationItem}
            {renderSizeOption}
            {renderIngredients}
            <div className="product-item-btn-wrapper">
              <a
                className="product-item-btn-shopee"
                href={
                  select == 'gravy'
                    ? 'https://shopee.co.th/%E0%B8%AD%E0%B8%B2%E0%B8%AB%E0%B8%B2%E0%B8%A3%E0%B9%80%E0%B8%9B%E0%B8%B5%E0%B8%A2%E0%B8%81%E0%B9%81%E0%B8%A1%E0%B8%A7-%E0%B9%81%E0%B8%84%E0%B8%97%E0%B9%80%E0%B8%97%E0%B8%AA%E0%B8%95%E0%B9%8C-%E0%B8%97%E0%B8%B9%E0%B8%99%E0%B9%88%E0%B8%B2%E0%B8%AB%E0%B8%99%E0%B9%89%E0%B8%B2%E0%B9%84%E0%B8%81%E0%B9%88-%E0%B9%83%E0%B8%99%E0%B8%99%E0%B9%89%E0%B8%B3%E0%B9%80%E0%B8%81%E0%B8%A3%E0%B8%A7%E0%B8%B5%E0%B9%88-%E0%B8%82%E0%B8%99%E0%B8%B2%E0%B8%94-75-%E0%B8%81%E0%B8%A3%E0%B8%B1%E0%B8%A1-x-12-%E0%B8%8B%E0%B8%AD%E0%B8%87-i.582216451.13757832483?sp_atk=48a463e1-72c8-4852-b1d9-41d719282c99'
                    : 'https://shopee.co.th/%E0%B8%AD%E0%B8%B2%E0%B8%AB%E0%B8%B2%E0%B8%A3%E0%B9%80%E0%B8%9B%E0%B8%B5%E0%B8%A2%E0%B8%81%E0%B9%81%E0%B8%A1%E0%B8%A7-%E0%B9%81%E0%B8%84%E0%B8%97%E0%B9%80%E0%B8%97%E0%B8%AA%E0%B8%95%E0%B9%8C-%E0%B8%97%E0%B8%B9%E0%B8%99%E0%B9%88%E0%B8%B2%E0%B8%AB%E0%B8%99%E0%B9%89%E0%B8%B2%E0%B9%84%E0%B8%81%E0%B9%88-%E0%B9%83%E0%B8%99%E0%B9%80%E0%B8%A2%E0%B8%A5%E0%B8%A5%E0%B8%B5%E0%B9%88-%E0%B8%82%E0%B8%99%E0%B8%B2%E0%B8%94-75-%E0%B8%81%E0%B8%A3%E0%B8%B1%E0%B8%A1-x-12-%E0%B8%8B%E0%B8%AD%E0%B8%87-i.582216451.13557837730?sp_atk=150c82d4-0e11-4ada-be5d-b79809a2de48'
                }>
                <img alt="cat's taste" className="product-item-shopee-icon" src="/assets/icons/shopee-icon.svg" />
                <div className="product-btn-title">SHOPEE</div>
              </a>
              <a
                className="product-item-btn-lazada"
                href={
                  select == 'gravy'
                    ? 'https://www.lazada.co.th/products/cats-taste-75-x-12-i2959070728-s10850040573.html?spm=a2o4m.seller.list.1.3867fd3aUUGqsP&mp=1'
                    : 'https://www.lazada.co.th/products/cats-taste-75-x-12-i2959138274-s10849974875.html?spm=a2o4m.seller.list.7.3867fd3aT54xUp&mp=1'
                }>
                <img alt="cat's taste" className="product-item-lazada-icon" src="/assets/icons/lazada-icon.svg" />
                <div className="product-btn-title">Lazada</div>
              </a>
            </div>
          </div>
        </div>
        {renderDescription}
      </div>
      {renderSlider}
    </div>
  )
}
